import rewriteCache from "./localStorage.js"
const cache = new rewriteCache()
// uni.setStorageSync("test2", "test2" ,{ timer: "1635244933411" })
function install(Vue) {
	cache.start()
	Vue.prototype.$storage = cache
}

export default {
	install
}
